import { React, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import axios from "axios";
import PropTypes from "prop-types";
import { JobEdit } from "..";
import { Star as StarIcon, Room as RoomIcon, StarBorder as StarBorderIcon, RestartAlt as RestartAltIcon, Close as CloseIcon } from "@mui/icons-material";

function JobTable(props) {
  const {
    jobs,
    selectedJob,
    setJob,
    userType,
    username,
    updateFavorites,
    setUpdateFavorites,
    updateTable,
    setUpdateTable,
    updateOffset,
    editedTable,
    setEditedTable,
    setJobOffset, 
    handleChange,
    setHandleChange, 
    currentPage, 
    setCurrentPage
  } = props;


  const handleJobFavorited = (jobId) => {
    const body = new FormData();
    body.append("jobId", jobId);
    body.append("pid", username);
    axios.post("/company/favoriteJob", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setUpdateFavorites(!updateFavorites);
        setHandleChange(true);
        setJobOffset(jobId);
      }
    });
  };

  const handleDelete = (jobId) => {
    const body = new FormData();
    body.append("jobId", jobId);
    axios.post("/company/deleteJob", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setUpdateTable(!updateTable);
      }
    });
  };

  const handleReset = (jobId) => {
    if(confirm("Are you sure you would like to reset this job's statistics?")) {
      const body = new FormData();
      body.append("jobId", jobId);
      axios.post("/company/resetJobStats", body).then((res) => {
        const data = res.data;
        if (data.success) {
          setEditedTable(!editedTable);
          setHandleChange(true);
          setJobOffset(jobId);
        }
      });
    }
  };

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    if (!handleChange) {
    }
    else {
      setHandleChange(false);
    }
  }, [jobs]);

  useEffect(() => {
    setItemOffset(0);
  }, [updateOffset]);

  // const setJobData = (job) => {
  //   setJob(job);
  //   //setJobOffset(job.jobId);
  // };

  const items = jobs.map((job, index) => (
    <div
      className={"JobButton-container flex p-2 rounded-md border-2 drop-shadow-2xl mb-2" + (job.jobId === selectedJob.jobId ? " border-brand-primary":"")}
      key={index}
    >
      <div className="JobButton-leftContainer w-full flex flex-col">
        <button
          type="button"
          className="w-full p-0 capitalize border-b last:border-b-0"
          onClick={() => setJob(job)}
        >
          <div className="JobButton-level text-base font-brand-primary flex mb-2">
            {Array.isArray(job.jobLevel) ?
              job.jobLevel.join(", ") :
              job.jobLevel}
          </div>

          <div className="JobButton-title text-xl font-bold font-brand-primary text-start flex mb-2">
            {job.title}
          </div>
          <div className="JobButton-level text-base font-brand-primary flex mb-2">
            {Array.isArray(job.jobType) ? job.jobType.join(", ") : job.jobType}
          </div>
          <div className="JobButton-location text-base mb-3 flex justify-start py-auto">
            <RoomIcon fontSize="medium" className="flex my-auto mr-1" />
            <div className="text-start">{job.location}</div>
          </div>
          <div className="JobButton-company text-base font-brand-primary flex">
            {job.company}
          </div>
          {(userType === "company" || userType === "admin") && (
            <div className="JobButton-viewCount text-base font-brand-primary flex">
              View Count: {job.viewCount}
            </div>
          )}
          {(userType === "company" || userType === "admin") && (
            <div className="JobButton-applyCount text-base font-brand-primary flex">
              Number Applied: {job.applyCount}
            </div>
          )}
        </button>
      </div>
      <div className="StudentButton-rightContainer">
        {userType === "student" && (
          <button
            className="flex"
            onClick={() => handleJobFavorited(job.jobId)}
          >
            {job.favorited === "true" ? (
              <StarIcon fontSize="large" className="fill-yellow-400" />
            ) : (
              <StarBorderIcon fontSize="large" className="fill-yellow-400" />
            )}
          </button>
        )}
        {(userType === "admin" || userType === "company") && (
          <button className="flex" onClick={() => handleDelete(job.jobId)}>
            <CloseIcon fontSize="large" className="fill-brand-primary" />
          </button>
        )}
        {(userType === "admin" || userType === "company") && (
          <JobEdit
            userType={userType}
            username={username}
            updateTable={editedTable}
            setUpdateTable={setEditedTable}
            job={job}
            setJobOffset={setJobOffset}
          />
        )}
        {(userType === "admin" || userType === "company") && (
          <button className="flex" onClick={() => handleReset(job.jobId)}>
            <RestartAltIcon fontSize="large" className="fill-brand-secondary" />
          </button>
        )}
      </div>
    </div>
  ));

  const itemsPerPage = 5;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
    if (jobs.length > newOffset) {
      setJob(jobs[newOffset]);
    }
  };

  if (jobs.length === 0) {
    return (
      <div className="JobTable bg-white p-2 mr-4 rounded-xl h-5/6">
        No jobs found.
      </div>
    );
  } else {
    return (
      <div className="JobTable bg-white p-2 mr-4 rounded-xl h-full" style={{ minHeight:"816px" }}>
        <ReactPaginate
          forcePage={currentPage}
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          className="flex w-full justify-between mb-6 mt-4 [&>li>a]:py-4 [&>li>a]:px-6 [&>li>a]:border [&>li>a]:rounded-lg [&>li.selected>a]:border-brand-primary"
        />
        <div className="JobTable-currentJobs overflow-y-auto">
          {currentItems}
        </div>
      </div>
    );
  }
}

JobTable.propTypes = {
  jobs: PropTypes.arrayOf({
    applyCount: PropTypes.number,
    applyDetails: PropTypes.string,
    company: PropTypes.string,
    companyLink: PropTypes.string,
    details: PropTypes.string,
    draft: PropTypes.bool,
    endDate: PropTypes.string,
    favorited: PropTypes.string,
    jobId: PropTypes.number,
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobType: PropTypes.arrayOf(PropTypes.string),
    link: PropTypes.string,
    location: PropTypes.string,
    skills: PropTypes.arrayOf(PropTypes.string),
    startDate: PropTypes.string,
    title: PropTypes.string,
    username: PropTypes.string,
    viewCount: PropTypes.number,
  }),
  selectedJob: PropTypes.shape({
    title: PropTypes.string,
    location: PropTypes.string,
    company: PropTypes.string,
    details: PropTypes.string,
    link: PropTypes.string,
    companyLink: PropTypes.string,
    applyDetails: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    jobType: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
    viewCount: PropTypes.number,
    applyCount: PropTypes.number,
    favorited: PropTypes.string,
    jobId: PropTypes.number,
  }),
  setJob: PropTypes.func,
  onJobApplied: PropTypes.func,
  userType: PropTypes.string,
  username: PropTypes.string,
  updateFavorites: PropTypes.bool,
  setUpdateFavorites: PropTypes.func,
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  updateOffset: PropTypes.bool,
  editedTable: PropTypes.bool,
  setEditedTable: PropTypes.func,
  setJobOffset: PropTypes.func,
  handleChange: PropTypes.bool,
  setHandleChange: PropTypes.func, 
  currentPage: PropTypes.string,
  setCurrentPage: PropTypes.func
};

JobTable.defaultProps = {
  jobs: [],
  selectedJob: { },
  setJob: () => { },
  onJobApplied: () => { },
  userType: "",
  username: "",
  updateFavorites: false,
  setUpdateFavorites: () => { },
  updateTable: false,
  setUpdateTable: () => { },
  updateOffset: false,
  editedTable: false,
  setEditedTable: () => { },
  setJobOffset: () => { }, 
  handleChange: false,
  setHandleChange: () => { },
  currentPage: "",
  setCurrentPage: () => { },
};

export default JobTable;
